export default class DataObjectField {
  constructor(text, fid) {
    this.__text = text;
    this._fid = fid.toString();
  }
}
